import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "_pos-r" }
const _hoisted_2 = {
  key: 0,
  class: "gfu-info-media"
}
const _hoisted_3 = { class: "gfu-info-media__aside _flex _jc-c" }
const _hoisted_4 = {
  key: 0,
  class: "gfu-media__body"
}
const _hoisted_5 = { class: "gfu-hd gfu-hd--h2 _mt-3" }
const _hoisted_6 = { class: "gfu-newsletter-banner-action" }
const _hoisted_7 = {
  key: 1,
  class: "gfu-info-media__body"
}
const _hoisted_8 = { class: "gfu-hd gfu-hd--h2 _mt-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_base_button = _resolveComponent("base-button")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.isBannerVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_themed_image, {
              class: "gfu-newsletter-banner-image",
              src: "/content/images/static/newsletter/newsletter-banner-image.svg",
              alt: "Newsletter banner"
            })
          ]),
          ($data.shouldDisplaySubscribeAction)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.Resources.PaymentSuccess.NewsletterBannerHeader), 1 /* TEXT */),
                _createElementVNode("p", null, _toDisplayString(_ctx.Resources.PaymentSuccess.NewsletterBannerParagraph), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_base_button, {
                    class: "_mt-3 _mb-3",
                    theme: "accent",
                    onClick: $options.signUpToNewsletters
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Resources.PaymentSuccess.NewsletterBannerSubscribeButton), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.Resources.PaymentSuccess.NewsletterBannerConfirmationHeader), 1 /* TEXT */),
                _createElementVNode("p", null, _toDisplayString(_ctx.Resources.PaymentSuccess.NewsletterBannerConfirmationParagraph), 1 /* TEXT */)
              ]))
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
  ]))
}